import gql from "graphql-tag";
import { LazyQueryHookOptions, QueryHookOptions, useLazyQuery, useQuery } from "@apollo/client";

import { USER_MAD_FRAGMENT, UserMadFragment } from "../../fragments";
import { Collection, UsersQueryVariables } from "../../types";

export const GET_USERS = gql`
  query getUsers(
    $companyId: ID
    $ids: [ID!]
    $notIds: [ID!]
    $q: String
    $groupId: ID
    $page: Int
    $per: Int
    $sortBy: String
    $direction: String
  ) {
    users(
      companyId: $companyId
      q: $q
      groupId: $groupId
      ids: $ids
      notIds: $notIds
      page: $page
      per: $per
      sortBy: $sortBy
      direction: $direction
    ) {
      collection {
        ...UserMadFragment
      }
      metadata {
        totalCount
      }
    }
  }
  ${USER_MAD_FRAGMENT}
`;

export type UsersData = { users: Collection<UserMadFragment> };

export const useLazyGetUsers = (options?: LazyQueryHookOptions<UsersData, UsersQueryVariables>) => {
  return useLazyQuery<UsersData, UsersQueryVariables>(GET_USERS, options);
};

export default (options?: QueryHookOptions<UsersData, UsersQueryVariables>) => {
  return useQuery<UsersData, UsersQueryVariables>(GET_USERS, options);
};
